import {connect} from "react-redux";
import {push} from "react-router-redux";
import {bindActionCreators} from "redux";

import SmallBoxComponent from "./SmallBox";

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
          push
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SmallBoxComponent);
